import { useStore } from "@nanostores/react";
import { Button } from "@wbly/ui";
import type { InstantSearch } from "instantsearch.js";
import { useEffect } from "react";
import type { KeyTextField } from "@prismicio/client";
import {
  $search,
  $isFilterBarLoaded,
  $filters,
} from "../../../pages/[locale]/personalized-books/stores/filters.store";
import { triggerDrawer } from "../../../stores/ui.store";
import { type Filter } from "../widgets/generateFacetRefinement";
import { Accordion } from "./Accordion";
import style from "./ActionBar.module.css";

const { chipContainerTitle, listContainer, drawerFooter } = style;

type FilterListProps = {
  filters: Filter[];
  filterClearTranslation: KeyTextField;
  filterApplyTranslation: KeyTextField;
  filterAppliedTranslation: KeyTextField;
};

export const Filters = ({
  filters,
  filterApplyTranslation,
  filterClearTranslation,
  filterAppliedTranslation,
}: FilterListProps) => {
  const searchInstance: Partial<InstantSearch> = useStore($search);
  const filterStore = useStore($filters);
  const hasActiveFilters = filterStore && Object.keys(filterStore).length > 0;
  let filtersCount = 0;

  if (hasActiveFilters) {
    filtersCount = Object.keys(filterStore).reduce(
      (acc, key) => acc + filterStore[key].length,
      0
    );
  }

  const applyFilters = () => {
    triggerDrawer("close");
  };

  const clearFilters = () => {
    searchInstance.helper.clearRefinements();
    searchInstance.helper.searchWithoutTriggeringOnStateChange();
    $filters.set({});
  };

  useEffect(() => {
    $isFilterBarLoaded.set(true);
  }, []);

  return (
    <div className={listContainer}>
      {hasActiveFilters && (
        <p className={chipContainerTitle}>{filterAppliedTranslation}</p>
      )}
      <div id="current-refinements"></div>
      {filters && (
        <Accordion>
          {filters.map((filter) => (
            <Accordion.Item key={filter.facetReference} title={filter.label}>
              <div id={filter.facetReference} />
            </Accordion.Item>
          ))}
        </Accordion>
      )}

      <div className={drawerFooter}>
        <Button
          type="button"
          outline
          onClick={clearFilters}
          data-testid="filters-clear-button"
        >
          {filterClearTranslation}{" "}
          {hasActiveFilters && <em>({filtersCount})</em>}
        </Button>
        <Button
          type="button"
          onClick={applyFilters}
          data-testid="filters-apply-button"
        >
          {filterApplyTranslation}
        </Button>
      </div>
    </div>
  );
};
